import React, { useEffect, useState } from "react";
import { Autocomplete, TextField, Chip, CircularProgress } from "@mui/material";
import { GetMultiSelectTestLib } from "../../services/TestLibService";
import { NotificationManager } from "react-notifications";
import CommonLoader from "./CommonLoader";

const MultiSelectTestLib = ({ value, onChange }) => {
  const [testLibOptions, setTestLibOptions] = useState([]);
  const [selectedTestCodes, setSelectedTestCodes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await GetMultiSelectTestLib();
        const testLibData = response.results.map((test) =>
          test.testCode.trim()
        );
        setTestLibOptions(testLibData);
        patchNewValues(testLibData);
       

        setLoading(false);
      } catch (error) {
        NotificationManager.error("Error fetching test library:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    patchNewValues(testLibOptions);
  }, [value,testLibOptions]);

  const patchNewValues = (testLibData) => {
    
    if (value && testLibData.length > 0) {
      const testCodesArray = value.split(",").map((code) => code.trim());
      setSelectedTestCodes(testCodesArray);
    }
   
  };

  useEffect(() => {
    if (onChange) {
      const selectedCodes = selectedTestCodes.join(",");
      onChange(selectedCodes);
    }
  }, [selectedTestCodes, onChange]);

  return (
    <>
      <Autocomplete
        multiple
        options={testLibOptions}
        getOptionLabel={(option) => option}
        value={selectedTestCodes}
        fullWidth
        size="small"
        // Always allow adding the same option multiple times by returning false
        isOptionEqualToValue={() => false}
        onChange={(event, newValue) => {
          setSelectedTestCodes(newValue);
        }}
        renderTags={(selected, getTagProps) =>
          selected.map((option, index) => (
            <Chip key={option} label={option} {...getTagProps({ index })} />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label="Other Tests to Add"
            variant="outlined"
            margin="dense"
          />
        )}
      />

      <CommonLoader loading={loading} />
    </>
  );
};

export default MultiSelectTestLib;
